export default "__VITE_ASSET__$ev673Cq__"